import { useState } from "react";
import { OpeningOrderFeeListResponseType } from "@sellar-io/api-v2/types";
import { FinanceSettingsLayout } from "./Components/FinanceSettingsLayout";
import { OOFCardList } from "./Components/OOFCardList";
import { OofDrawer } from "./Components/OofDrawer";
import { useMediaQuery } from "usehooks-ts";
import { OOFTable } from "./Components/OOFTable";
import { TableHeader } from "../../../components/table/TableHeader";
import { useDebounce } from "use-debounce";

export const FinanceSettingsOof = () => {
  const [active, setActive] = useState(false);
  const [selectedOof, setSelectedOof] =
    useState<OpeningOrderFeeListResponseType[number]>();
  const [search, setSearch] = useState("");

  const [debouncedSearchValue] = useDebounce(search, 500);

  const isDesktop = useMediaQuery("(min-width: 1200px)");

  return (
    <FinanceSettingsLayout>
      <div className="container mx-auto mt-6 max-w-[1300px]">
        <TableHeader
          search={search}
          searchPlaceholder="Search order #, customer..."
          setSearch={setSearch}
        />
        {isDesktop ? (
          <OOFTable
            setSelectedOof={setSelectedOof}
            setActive={setActive}
            search={debouncedSearchValue}
          />
        ) : (
          <OOFCardList
            setSelectedOof={setSelectedOof}
            setActive={setActive}
            search={debouncedSearchValue}
          />
        )}
      </div>
      <OofDrawer active={active} setActive={setActive} oof={selectedOof} />
    </FinanceSettingsLayout>
  );
};
